import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface IProps {
  title: string;
  open: boolean;
  setOpen?: ((value: boolean) => void) | null;
  onConfirm: ((value: boolean) => void) | null;
  hideButtons?: boolean;
  className?: string;
  children: ReactNode;
  maxWidth?: string;
}

const FuelConfirmDialog = ({
  title = null,
  open = false,
  setOpen = null,
  onConfirm = null,
  hideButtons = false,
  className = null,
  children = null,
  maxWidth = 'md',
}: IProps) => {
  const [isOpen, setIsOpen] = useState(open);
  if (hideButtons !== true) hideButtons = false;

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    if (setOpen) setOpen(false);
    if (onConfirm) onConfirm(false);
  };

  return (
    <Dialog className={className} onClose={handleClose} open={isOpen} maxWidth={maxWidth} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <Box position="absolute" top={0} right={0}>
        <IconButton onClick={handleClose}>
          <Close />
        </IconButton>
      </Box>
      <DialogContent>{children}</DialogContent>
      {!hideButtons && (
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="success"
            variant="contained"
            onClick={() => {
              if (setOpen) setOpen(false);
              setIsOpen(false);
              if (onConfirm) onConfirm(true);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default FuelConfirmDialog;
